import * as angular from "angular";
import {SyncService} from "./sync-service.service";
import {BringozArray} from "./bringoz-array";
import {BringozObject} from "./bringoz-object";
import {ILogService, IQService, ITimeoutService} from "angular";
import {LocalStoreService} from "./local-store-service.service";
import {SplitService} from "../commons/services/split-service.service";
import {BringozApi} from "./models/bringoz-api.model";
import {DataStoreConfig} from "./models/datastore-config.model";
import {PushNotificationsConfig} from "./models/push-notifications-config.model";

export type $bringozFactory = <T>(id: string, api: BringozApi, dataStoreConfig?: DataStoreConfig,
                                  pushNotificationsConfig?: PushNotificationsConfig) => BringozObject<T> | BringozArray<T>;

/* @ngInject */
function BringozFactory($q: IQService,
                        $log: ILogService,
                        $timeout: ITimeoutService,
                        syncService: SyncService,
                        localStoreService: LocalStoreService,
                        splitService: SplitService) {

  const currentApiCalls: any = {};
  const $$onUpdateTriggers: any = {};

  function $bringoz<T>(id: string, api: BringozApi, dataStoreConfig?: DataStoreConfig, pushNotificationsConfig?: PushNotificationsConfig) {
    return id ?
      new BringozObject<T>($q, $log, $timeout, syncService, localStoreService, splitService, id, api, dataStoreConfig, pushNotificationsConfig, currentApiCalls, $$onUpdateTriggers) :
      new BringozArray<T>($q, $log, $timeout, syncService, localStoreService, splitService, api, dataStoreConfig, pushNotificationsConfig);
  }

  return $bringoz;
}

angular
  .module('bringoz.admin.persistence')
  .factory('$bringozFactory', BringozFactory);
